import { signal } from 'services/SignalsService'

const name = 'EXPANDING-WILD'

function toPromise([reel]) {
  return signal.promise(`EXPANDED-${reel}`)
}

async function execute() {
  return Promise.all(game.models.WinModel.get().wild.map(toPromise))
}

export function getExpandingWildAction() {
  return {
    name,
    execute,
  }
}
